import { put, takeEvery } from "redux-saga/effects";
import { Auth } from "../../services";
import type { LoginAction, LogoutAction } from "../types";

function* doLogin(action: LoginAction) {
  try {
    yield Auth.signIn(action.email, action.password);
    const credentials = yield Auth.currentUserCredentials();
    const session = yield Auth.currentSession();
    const { email } = session.idToken.payload;
    yield put({
      type: "LOGIN_SUCCESS",
      userId: credentials.identityId,
      email,
    });
  } catch (e) {
    yield put({
      type: "LOGIN_FAIL",
    });
    alert(e.message);
  }

  yield put({
    type: "LOAD_LOG",
  });
  yield put({
    type: "LOAD_INSTALLED_HABITS",
  });
}

function* loadLogin() {
  try {
    const credentials = yield Auth.currentUserCredentials();
    const session = yield Auth.currentSession();
    const { email } = session.idToken.payload;
    yield put({
      type: "LOGIN_LOADED",
      isAuthenticated: session != null,
      userId: credentials.identityId,
      email,
    });
  } catch (e) {
    /* alert(e); */
    yield put({
      type: "LOGIN_LOADED",
      isAuthenticated: false,
    });
  }

  yield put({
    type: "LOAD_LOG",
  });
  yield put({
    type: "LOAD_INSTALLED_HABITS",
  });
}

function* doLogout(action: LogoutAction) {
  try {
    yield Auth.signOut();
    yield put({
      type: "LOGOUT_SUCCESS",
    });
  } catch (e) {
    yield put({
      type: "LOGOUT_FAIL",
    });
    alert(e.message);
  }

  yield put({
    type: "LOAD_LOG",
  });
}

function* loginSaga() {
  yield takeEvery("LOGIN", doLogin);
  yield takeEvery("LOAD_LOGIN", loadLogin);
  yield takeEvery("LOGOUT", doLogout);
}

export default loginSaga;
